import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames'

const IconUserSVG = ({color, className, ...rest}) => {
    return (
        <svg {...rest} width="26.738" height="26.738" viewBox="0 0 26.738 26.738"
            className={classNames(['svg-icon svg-affiliate', className])}>
            <path fill="none" d="M0,0H26.738V26.738H0Z" />
            <path fill={color} d="M12.913,12.913A4.456,4.456,0,1,0,8.456,8.456,4.455,4.455,0,0,0,12.913,12.913Zm0,2.228C9.938,15.141,4,16.634,4,19.6v1.114a1.117,1.117,0,0,0,1.114,1.114h15.6a1.117,1.117,0,0,0,1.114-1.114V19.6C21.826,16.634,15.887,15.141,12.913,15.141Z" transform="translate(0.456 0.456)" />
        </svg>
    );
};

IconUserSVG.propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

IconUserSVG.defaultProps = {
    color: '#ffffff',
    className: '',
};

export default IconUserSVG;